import { getDayLabelNumber } from "./wordForm";
import { getItemFromArrayOnCreatedAt } from "./search";
import { isSameDateOnDay } from "./dates";

/**
 * Получение ID штрафа из истории для билета
 * @param {Object} history История залогового билета
 * @returns {String} ID штрафа
 */
export function getFineIdOperation(history) {
  let fineId = null;

  if (!!history && !!history._field) {
    if (
      !!history._field.fine &&
      Array.isArray(history._field.fine) &&
      history._field.fine.length > 0
    ) {
      history._field.fine.forEach(fine => {
        if (history._field.hash_old === fine.bilet_hash) {
          fineId = fine._id;
        }
      });
    }
  }

  return fineId;
}

/**
 * Получить подготовленные штрафы для истории
 * @param {Object} history История залогового билета
 * @returns {Object} {list: [{sum: 0, description: 'Описание штрафа'}], allSum: 0} - Список штрафов и сумма всех штрафов.
 */
export function getFinesToHistory(history, separator = "=") {
  const fines = {
    list: [],
    allSum: 0
  };

  if (!!history && !!history._field) {
    if (
      !!history._field.fine &&
      Array.isArray(history._field.fine) &&
      history._field.fine.length > 0 &&
      history._method !== "close"
    ) {
      history._field.fine.forEach(fine => {
        if (history._field.hash_old === fine.bilet_hash) {
          fines.allSum += fine.sum_fine;

          if (fine._type === "delay") {
            fines.list.push({
              ...fine,
              description:
                "Задержка з/б на " +
                getDayLabelNumber(fine.days_fine) +
                ` ${separator} `,
              sum: fine.sum_fine
            });
          } else {
            fines.list.push({
              description: `Потеря з/б ${separator}`,
              sum: fine.sum_fine
            });
          }
        }
      });
    }
  }

  return fines;
}

export function getFineDaysOperation(history) {
  let descriptionFine = "";

  if (!!history && !!history._field) {
    if (
      !!history._field.fine &&
      Array.isArray(history._field.fine) &&
      history._field.fine.length > 0
    ) {
      history._field.fine.forEach(fine => {
        if (history._field.hash_old === fine.bilet_hash) {
          if (fine._type === "delay") {
            descriptionFine = getDayLabelNumber(fine.days_fine) + " - ";
          } else {
            descriptionFine = "Потеря з/б - ";
          }
        }
      });
    }
  }

  return descriptionFine;
}

export function getFineSumOperation(history) {
  let sumFine = "-";

  if (!!history && !!history._field) {
    if (
      !!history._field.fine &&
      Array.isArray(history._field.fine) &&
      history._field.fine.length > 0
    ) {
      history._field.fine.forEach(fine => {
        if (history._method !== "create") {
          if (history._field.hash_old === fine.bilet_hash) {
            sumFine = fine.sum_fine;
          }
        }
      });
    }
  }

  return sumFine;
}

/**
 * Получение суммы для истории (Только для операций: Создание)
 * @param {Object} currentHistory Текущая история
 * @param {Object} isReturnOnlyNumber Вернуть как число?
 * @returns {Number|String} Сумма
 */
export function getGiveOnly(currentHistory, isReturnOnlyNumber) {
  let sumGive = "";

  if (currentHistory._method === "create") {
    sumGive = currentHistory._field.sum_give;
  } else {
    return isReturnOnlyNumber ? 0 : "-";
  }

  return sumGive;
}

/**
 * Получение суммы для истории (Только для операций: Списание)
 * @param {Object} currentHistory Текущая история
 * @param {Object} isReturnOnlyNumber Вернуть как число?
 * @returns {Number|String} Сумма
 */
export function getCloseOnly(currentHistory, isReturnOnlyNumber) {
  let sumClose = "";

  if (currentHistory._method === "close") {
    sumClose = currentHistory._options.sum;
  } else {
    return isReturnOnlyNumber ? 0 : "-";
  }

  return sumClose;
}

/**
 * Получение суммы для истории (Только для операций: Пролонгация, Выкуп)
 * @param {Object} currentHistory Текущая история
 * @param {Object} isReturnOnlyNumber Вернуть как число?
 * @returns {Number|String} Сумма
 */
export function getSumPercent(currentHistory, isReturnOnlyNumber) {
  let sumPercent = "";

  if (
    currentHistory._method === "create" ||
    currentHistory._method === "close"
  ) {
    return isReturnOnlyNumber ? 0 : "-";
  } else if (currentHistory._method === "repayment") {
    sumPercent = currentHistory._field.sum_percent;
  } else {
    sumPercent =
      currentHistory._options && currentHistory._options.sum
        ? currentHistory._options.sum
        : 0;
  }

  return sumPercent;
}

/**
 * Получение общей полученной суммы для истории (Только для операций: Пролонгация, Выкуп, Списание)
 * @param {Object} currentHistory Текущая история
 * @param {Number} sumPercent Сумма полученных процентов
 * @param {Number} finesAllSum Сумма полученных штрафов
 * @param {Object} isReturnOnlyNumber Вернуть как число?
 * @returns {Number} Сумма
 */
export function getSumAll(
  currentHistory,
  sumPercent,
  finesAllSum,
  isReturnOnlyNumber
) {
  if (currentHistory._method === "create") {
    if (isReturnOnlyNumber) {
      return 0;
    } else {
      sumPercent = "-";
    }
  } else if (currentHistory._method === "repayment") {
    return (
      (typeof sumPercent === "number" ? sumPercent : 0) +
      finesAllSum +
      currentHistory._field.sum_give
    );
  } else {
    return (typeof sumPercent === "number" ? sumPercent : 0) + finesAllSum;
  }

  return sumPercent;
}

export function getNewSumPercent(
  historyList,
  currentHistory,
  isReturnOnlyNumber
) {
  let newSumPercent = isReturnOnlyNumber ? 0 : "";

  if (!!historyList && Array.isArray(historyList) && historyList.length > 0) {
    let typesZero = ["repayment", "close"];

    if (typesZero.indexOf(currentHistory._method) !== -1) {
      newSumPercent = isReturnOnlyNumber ? 0 : "-";
    } else {
      newSumPercent =
        currentHistory._field && currentHistory._field.sum_percent
          ? currentHistory._field.sum_percent
          : isReturnOnlyNumber
          ? 0
          : "-";
    }
  }

  return newSumPercent;
}

/**
 * Проверка истории на наличие ошибок с кассовым ордером
 * @param {Object} Параметры истории {createdAt, getSumAll, sumPercentNew, sumReturn, sumGive}
 * @param {Array} blanks Список бланков
 * @returns {Object} Ошибки в {createdAt: false, sumAll: false, sumReturn: false}
 */
export function checkBiletHistoryWithBlank(
  { createdAt, getSumAll, sumPercentNew, sumReturn, sumGive, method },
  blanks
) {
  const historyErrors = {
    createdAt: false,
    sumAll: false,
    sumReturn: false
  };

  if (method !== "create") {
    if (blanks && blanks.length) {
      const blank = getItemFromArrayOnCreatedAt(
        "created_at",
        createdAt,
        blanks
      );

      if (blank) {
        // Выкуп
        if (method === "repayment") {
          historyErrors.createdAt = !isSameDateOnDay(
            createdAt,
            blank.created_at
          );
          historyErrors.sumAll = getSumAll !== blank.sum;
          historyErrors.sumReturn = false;
        } else {
          // Обычная операция: Продление
          historyErrors.createdAt = !isSameDateOnDay(
            createdAt,
            blank.created_at
          );
          historyErrors.sumAll = getSumAll !== blank.sum;
          historyErrors.sumReturn = sumReturn - sumPercentNew !== sumGive;
        }
      } else {
        historyErrors.createdAt = true;
        historyErrors.sumAll = true;
        historyErrors.sumReturn = true;
      }
    }
  }

  return historyErrors;
}

/**
 * Проверка бланка на наличие ошибок с историей
 * @param {Object} Параметры бланка {createdAt, sum}
 * @param {Array} historys Список историй
 * @returns {Object} Ошибки в {createdAt: false, sum: false}
 */
export function checkBlankWithBiletHistory({ createdAt, sum }, historys) {
  const blankErrors = {
    createdAt: false,
    sum: false
  };

  if (historys && historys.length) {
    const history = getItemFromArrayOnCreatedAt(
      "created_at",
      createdAt,
      historys
    );

    if (history) {
      if (history._method !== "create") {
        const fines = getFinesToHistory(history);
        const sumPercent = getSumPercent(history);
        const sumGetAll =
          (typeof sumPercent === "number" ? sumPercent : 0) + fines.allSum;

        if (history._method === "repayment") {
          blankErrors.createdAt = !isSameDateOnDay(
            createdAt,
            history.created_at
          );
          blankErrors.sum = history._field.sum_give + sumGetAll !== sum;
        } else {
          blankErrors.createdAt = !isSameDateOnDay(
            createdAt,
            history.created_at
          );
          blankErrors.sum = sumGetAll !== sum;
        }
      }
    } else {
      blankErrors.createdAt = true;
      blankErrors.sum = true;
    }
  }

  return blankErrors;
}

/**
 * Получение объекта с суммами из истории действий
 * @param {Array} filialHistorys Список историй
 * @returns {Object} Ошибки в {sum_add: 0, sum_remove: 0, sum_remove_to_sale: 0, sum_give: 0, sum_return: 0, sum_percent: 0, sum_fine: 0, sum_income: 0, sum_income_with_return: 0}
 */
export function getFilialSumsHistorys(filialHistorys) {
  let filialSums = {
    sum_add: 0,
    sum_remove: 0,
    sum_remove_to_sale: 0,

    sum_give: 0,
    sum_return: 0,
    sum_percent: 0,
    sum_fine: 0,

    sum_income: 0,
    sum_income_with_return: 0
  };

  if (
    filialHistorys &&
    Array.isArray(filialHistorys) &&
    filialHistorys.length
  ) {
    for (let history of filialHistorys) {
      const sumGiveOnly = getGiveOnly(history, true);
      const sumGetPercent = getSumPercent(history, true);
      const fines = getFinesToHistory(history);
      const sumGetAll = getSumAll(history, sumGetPercent, fines.allSum, true);

      filialSums.sum_give += sumGiveOnly;
      filialSums.sum_percent += sumGetPercent;
      filialSums.sum_fine += fines.allSum;
      filialSums.sum_income_with_return += sumGetAll;
    }
  }

  return filialSums;
}
